import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCross16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCross16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M11.976 3.176a.6.6 0 0 1 .848.849L8.848 8l3.976 3.976a.6.6 0 0 1-.848.849L8 8.849l-3.976 3.975a.6.6 0 0 1-.848-.849L7.15 8 3.176 4.025a.6.6 0 0 1 .848-.849L8 7.152z"
            />
        </svg>
    );
}
export default memo(IconCross16);
